import React, { useEffect, useState } from "react";
import "./styleOrderDetails.css";
import { getOrderHistory } from "../../services/revenueServices";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const INCSUBOrderDetails = ({ onClose, orderId }) => {

  const [historyLoader, setHistoryLoader] = useState(false);
  const [orderHistory, setOrderHistory] = useState();
  const navigate = useNavigate();
  const handleOrderHistory = async (orderId) => {
    setHistoryLoader(true);
    try {
      const orderHistoryData = await getOrderHistory(orderId);
      if (orderHistoryData.status === 200) {
 
        setOrderHistory(orderHistoryData.data.data)
      } else if (orderHistoryData.status === 301) {
        toast.error("Network Error");
      } else if (orderHistoryData.status === 500) {
        toast.error("Internal server error");
      } else if (orderHistoryData.status === 401) {
        window.localStorage.setItem('userData', null);
        window.localStorage.setItem('token', null);
        navigate('/login');
      } else if (![200, 401].includes(orderHistoryData.status)) {
        toast.error(orderHistoryData.orderHistory.message)
      }
    } catch (error) {
      toast.error("Something went wrong")
    } finally {
      setHistoryLoader(false);
    }

  }
  useEffect(() => {
    if (orderId) {
      handleOrderHistory(orderId);
    }
  }, [])

  return (
    <div className="INCSUBOrderDetails_popup-overlay" onClick={() => onClose(false)}>
      <div className="INCSUBOrderDetails_popup" onClick={(e) => e.stopPropagation()}>
        {!historyLoader && orderHistory ? <>
          <h2>Order Details</h2>
          <div className="INCSUBOrderDetails_order_details_container">
            <table className="INCSUBOrderDetails_payment-details-table">
              <thead>
                <tr>
                  <th>Payment ID</th>
                  <th>Order ID</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Amount</th>
                  <th>Fee</th>
                  <th>Tax</th>
                  <th>Refunded</th>
                  <th>Method (Bank)</th>
                  <th>Transaction ID</th>
                  <th>Status</th>
                  <th>Description</th>
                  <th>Fee Bearer</th>
                  <th>Currency</th>
                  <th>Captured</th>
                  <th>International</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {orderHistory && orderHistory.map((order, index) => (
                  <tr key={index}>
                    <td>{order.id}</td>
                    <td>{order.orderId}</td>
                    <td>{order.contact}</td>
                    <td>{order.email}</td>
                    <td>₹{order.amount}</td>
                    <td>₹{order.fee}</td>
                    <td>₹{order.tax}</td>
                    <td>₹{order.amountRefunded}</td>
                    <td>{order.method.toUpperCase()} ({order.bank})</td>
                    <td>{order.bankTransactionId}</td>
                    <td>{order.status}</td>
                    <td>{order.description}</td>
                    <td>{order.feeBearer}</td>
                    <td>{order.currency}</td>
                    <td>{order.captured ? "Yes" : "No"}</td>
                    <td>{order.international ? "Yes" : "No"}</td>
                    <td>{new Date(order.createdAt * 1000).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button className="INCSUBOrderDetails_close-btn" onClick={() => onClose(false)}>Close</button>
        </> : <div className="INCSUBOrderDetails_orderHistory_loader_container"><div className='categoryloader' /> </div>}
      </div>
    </div>
  );
};

export default INCSUBOrderDetails;
